import { Button } from "reactstrap";
import styled, { createGlobalStyle } from "styled-components";

export const TipoEventoBtn = styled(Button)`
  flex: 1 !important;
  font-size: inherit;
  background: #f6f9fc;
  height: 54px;
  color: #5e72e4;
  min-width: min-content;
  font-weight: 'normal'
`;

export const DivCard = styled.div`
  white-space: initial;
  background-color: white;
  padding: 8px;
  margin: auto auto 10px;
  border-radius: 8px;
  width: 370px;
  max-width: 370px;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: 100ms;
  border-left: ${props => props.cardColor ? `5px solid ${props.cardColor}` : 'none'};
  
  :hover {
    background-color: #ffffff;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }
`;

export const KanbanGlobalStyle = createGlobalStyle`
  .kanban-board-wrapper .smooth-dnd-container.vertical {
    min-height: 120px;
    border-radius: 6px;
    transition: background-color 120ms ease, box-shadow 120ms ease;
  }

  /* Quando o usuário está arrastando algo, todas as lanes ficam levemente destacadas */
  .kanban-board-wrapper.is-dragging .smooth-dnd-container.vertical {
    background-color: rgba(94, 114, 228, 0.04);
    outline: 2px dashed rgba(94, 114, 228, 0.25);
    outline-offset: -4px;
  }

  /* Lane que está recebendo o drop (hover do card arrastado) — destaque mais forte */
  .kanban-board-wrapper .smooth-dnd-container.vertical.smooth-dnd-drop-preview-default-class,
  .kanban-board-wrapper .smooth-dnd-container.vertical:has(.smooth-dnd-drop-preview-constant-class) {
    background-color: rgba(46, 204, 113, 0.08);
    outline: 2px dashed #2dce89;
    outline-offset: -4px;
  }

  /* Drop preview (espaço reservado mostrando onde o card vai cair) */
  .kanban-board-wrapper .smooth-dnd-drop-preview-default-class,
  .kanban-board-wrapper .smooth-dnd-drop-preview-constant-class {
    background-color: rgba(46, 204, 113, 0.18) !important;
    border: 2px dashed #2dce89 !important;
    border-radius: 8px !important;
    margin: 4px auto 10px !important;
  }
`;
